[
  {
    "id": 1,
    "name": "Alumbrado",
    "className": "lighting",
    "urlImg": "assets/imagenes/Logos/ICNLogoOrion.svg",
    "pageUrl": "https://alumbrado.azurewebsites.net/"
  },
  {
    "id": 2,
    "name": "Cargadores",
    "className": "chargers",
    "urlImg": "assets/imagenes/Logos/ICNCargadoressvg.svg",
    "pageUrl": "https://usrcargadores.azurewebsites.net/"
  },
  {
    "id": 3,
    "name": "Suministradores",
    "className": "suppliers",
    "urlImg": "assets/imagenes/Logos/ICNSolfix.svg",
    "pageUrl": "https://smfrontend.azurewebsites.net/"
  },
  {
    "id": 4,
    "name": "Instaladores",
    "className": "installers",
    "urlImg": "assets/imagenes/Logos/ICNSolfixInsta.svg",
    "pageUrl": "https://instafrontend.azurewebsites.net"
  },
  {
    "id": 5,
    "name": "Monitorizacion",
    "className": "monitoring",
    "urlImg": "assets/imagenes/Logos/ICNSolfix.svg",
    "pageUrl": "https://monitorizacion.sol-fix.es/"
  }
]
